import API from "core/networks/API";
import { IApiResponseSuccess } from "core/networks/Interfaces";
import { AxiosResponse } from "axios";
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_DATA_REQUEST,
  UPDATE_REQUEST_TYPE,
  fetchDataSuccess,
  fetchDataError,
} from './actions';
import {
  IAiImgResponse,
  FetchDataRequestAction,
} from './types';
import { API_AI_CHEF_IMG, API_UPDATE_REQUEST_TYPE } from "../api";
// import { config } from "core/config/app"

function* fetchDataAiChefImg(action: FetchDataRequestAction) {
  try {
    const response: AxiosResponse<IApiResponseSuccess<IAiImgResponse>> = yield call(
      API.post,
      API_AI_CHEF_IMG,
      action.payload
    );
    console.log('response fetchDataAiChefImg', response);
    
    yield put(fetchDataSuccess(response.data.data));
  } catch (error) {
    yield put(fetchDataError(error as Error));
  }
}

function* updateRequestTypeSaga(action: any): Generator {
  yield call(
    API.post,
    API_UPDATE_REQUEST_TYPE.replace(':id', action.payload.id),
    action.payload
  );
}

export default function* IngredientSaga() {
  yield takeLatest(FETCH_DATA_REQUEST, fetchDataAiChefImg);
  yield takeLatest(UPDATE_REQUEST_TYPE, updateRequestTypeSaga);
}
